import React from "react";
import {
  Card,
  Progress,
  Space,
  Avatar,
  Typography,
} from "antd";
import {
  DollarOutlined,
  TrophyOutlined,
  EditOutlined,
  DeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const TargetCard = ({ title, date, actions = [], reward, members, onDelete, onEdit }) => {

  return (
    <Card style={{ borderRadius: 16 }} bodyStyle={{ padding: 20 }}>
      {/* Header */}
      <Space
        style={{ justifyContent: "space-between", width: "100%" }}
        align="start"
      >
        <Space align="start">
          <Avatar
            icon={<DollarOutlined />}
            style={{ background: "#f0e6ff", color: "#722ed1" }}
          />
          <Space direction="vertical" size={0}>
            <Text strong style={{ fontSize: 16 }}>
              {title}
            </Text>
            <Text type="secondary">{date}</Text>
          </Space>
        </Space>

        <Space>
          {onEdit && <EditOutlined style={{ cursor: "pointer" }} onClick={onEdit}/>}
          {onDelete &&
            <DeleteOutlined
              style={{ color: "red", cursor: "pointer" }}
              onClick={onDelete}
            />
          }
        </Space>
      </Space>

      {/* Multiple Actions Progress */}
      <div style={{ marginTop: 16 }}>
        {actions.map((action, index) => {
          const currentProgress = action.progress || 0;
          const target = action.target || 0;
          const percent = target > 0 ? Math.round((currentProgress / target) * 100) : 0;

          // 🎨 Dynamic color logic
          let progressColor = "#ff4d4f"; // red default (< 50%)
          if (percent >= 75) progressColor = "#52c41a"; // green
          else if (percent >= 50) progressColor = "#faad14"; // yellow          

          return (
            <div key={index} style={{ marginBottom: 16 }}>
              <Space
                style={{
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Text type="secondary">{onEdit ? action.action_name : action.name}</Text>
                <Text strong>
                  {currentProgress}/{target}
                </Text>
              </Space>

              <Progress
                percent={percent}
                showInfo={false}
                strokeColor={progressColor}
              />
            </div>
          );
        })}
      </div>

       {/* Reward + Members */}
       <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          marginTop: 12,
        }}
      >
        <Space>
          <TrophyOutlined style={{ color: "#faad14" }} />
          <Text type="secondary">{reward}</Text>
        </Space>

        {members &&        
          <Space>
            <UserOutlined />
            <Text type="secondary">{members} team members</Text>
          </Space>
        }
      </Space>
    </Card>
  );
};

export default TargetCard;
